/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import 'jquery.transit';
import Section2 from './Section2';

// npm install animate.css
import 'animate.css/animate.min.css';

function Section1() {

    useEffect(() => {
        $(".role_box").eq(0).trigger('click');

        const handleResize = () => {
            // 윈도우 크기 변경 시 수행할 작업
            updateRoleElements();
        };

        const updateRoleElements = () => {
            // 크기가 변경될 때 수행할 업데이트 로직
            const lolPositionIndex = lp.findIndex(item => item[1] === lolPosition);
            var boxLeft = $(".role_box p").eq(lolPositionIndex).offset().left
            var role_box = $(".role_box").width()
            var role_circle = (role_box - $(".role_circle").width()) / 2
            var role_circle2 = (role_box - $(".role_circle2").width()) / 2
            var role_bar = (role_box - $(".role_bar").width()) / 2
            $(".role_circle").css({ left: boxLeft + role_circle + "px" })
            $(".role_circle2").css({ left: boxLeft + role_circle2 + "px" })
            $(".role_bar").css({ left: boxLeft + role_bar + "px" })
        };

        // 이벤트 리스너 등록
        window.addEventListener('resize', handleResize);

        // 컴포넌트가 마운트 해제되면 이벤트 리스너 제거
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    let [topLeft, setTopLeft] = useState(100)

    let [lolPosition, setLolPosition] = useState("assassin")
    let [lolPosition2, setLolPosition2] = useState("assassin")

    const lp = [
        ["암살자", "assassin"],
        ["전사", "warrior"],
        ["마법사", "wizard"],
        ["원딜", "dealer"],
        ["서포터", "supporter"],
        ["탱커", "tanker"]
    ];

    const cp = [
        ["아칼리", "섬기는 이 없는 암살자"],
        ["야스오", "용서받지 못한 자"],
        ["럭스", "광명의 소녀"],
        ["징크스", "난폭한 말괄량이"],
        ["쓰레쉬", "지옥의 간수"],
        ["레오나", "여명의 빛"]
    ]

    const vdURL = [
        "https://www.leagueoflegends.com/static/assassin-c026c1f2ea83776334e2adb286bc5781.webm",
        "https://www.leagueoflegends.com/static/fighter-2bab9d1a1e22d6863bb23788b838cae4.webm",
        "https://www.leagueoflegends.com/static/mage-d8800ed4cf091410d8f6cc730f003cad.webm",
        "https://www.leagueoflegends.com/static/marksman-bd0982ab3e28c88198cb868ce386bd06.webm",
        "https://www.leagueoflegends.com/static/support-0b11ba20e96f4aeedda6b790df758b67.webm",
        "https://www.leagueoflegends.com/static/tank-10428d66145a464122d5ed6d18ac3281.webm"
    ]

    const handelClickRole = (role, image1, image2, index) => {
        const lolPositionIndex = lp.findIndex(item => item[1] === lolPosition);
        $(".role_box img").eq(lolPositionIndex).removeClass("clickedElement");
        $(".role_box img").eq(lolPositionIndex).attr("src", `${process.env.PUBLIC_URL}/${lolPosition}2.png`).stop().animate({ width: "30px" }, 500);
        $(".role_box h2").eq(lolPositionIndex).css({ marginTop: "30px", color: "#bac2cc" });
        $(".role_box p").eq(lolPositionIndex).css({ color: "#bac2cc", opacity: 1 });
        $(".role_bar").css({ transition: "clip-path 0s", clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)" })

        setLolPosition(role);
        $(".role_box img").eq(index).attr("src", image1).stop().animate({ width: "40px" }, 100);
        $(".role_box h2").eq(index).css({ marginTop: "37px", color: "#000" });
        $(".role_box p").eq(index).css({ opacity: 0 });

        var boxLeft = $(".role_box p").eq(index).offset().left
        var role_box = $(".role_box").width()
        var role_circle = (role_box - $(".role_circle").width()) / 2
        var role_circle2 = (role_box - $(".role_circle2").width()) / 2
        var role_bar = (role_box - $(".role_bar").width()) / 2
        $(".role_circle").css({ left: boxLeft + role_circle + "px", opacity: 1 })
        $(".role_circle2").stop().animate({ left: boxLeft + role_circle2 + "px" }, function () {
            $(".role_bar").css({ left: boxLeft + role_bar + "px", transition: "clip-path 0.5s", clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0)" })
        })

        $(".cp_name").text(cp[index][0])
        $(".cp_txt").text(cp[index][1])
        $(".role_box img").eq(index).addClass("clickedElement");
        $(".section1 video").attr("src", vdURL[index]);

        if (topLeft == 0) {
            // 위에서 아래
            setTopLeft(100)
            $("#role_img_box").css({ transition: "clip-path 0.5s", clipPath: "polygon(100% 0, 100% 50%, 50% 100%, 0 100%, 0 0)" })
            $("#role_img_box2").css({ transition: "clip-path 0.5s", clipPath: "polygon(100% 50%, 100% 50%, 100% 100%, 50% 100%, 50% 100%)" })
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(50% 0, 100% 0, 0 100%, 0 50%, 0 0)" })
                $("#role_img_box2").css({ clipPath: "polygon(100% 0, 100% 50%, 100% 100%, 50% 100%, 0 100%)" })
            }, 150)
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(50% 0, 50% 0, 0 50%, 0 50%, 0 0)" })
                $("#role_img_box2").css({ clipPath: "polygon(50% 0, 100% 0, 100% 100%, 0 100%, 0 50%)" })
            }, 300)
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(0 0, 0 0, 0 0, 0 0, 0 0)" })
                $("#role_img_box2").css({ clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 0)" })
            }, 450)
            setTimeout(() => {
                setLolPosition2(role);
            }, 600)
            setTimeout(() => {
                $("#role_img_box").css({ transition: "clip-path 0s", clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0, 0 0)" })
                $("#role_img_box2").css({ transition: "clip-path 0s", clipPath: "polygon(0 0, 0 0, 0 0, 0 0, 0 0)" })
            }, 750)
        } else {
            // 아래에서 위
            setTopLeft(0)
            $("#role_img_box").css({ transition: "clip-path 0.5s", clipPath: "polygon(0 100%, 100% 100%, 100% 0, 50% 0, 0 50%)" })
            $("#role_img_box2").css({ transition: "clip-path 0.5s", clipPath: "polygon(50% 0, 50% 0, 0 50%, 0 50%, 0 0)" })
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(0 100%, 100% 100%, 100% 0, 100% 0, 0 100%)" })
                $("#role_img_box2").css({ clipPath: "polygon(100% 0, 100% 0, 0 100%, 0 100%, 0 0)" })
            }, 150)
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(50% 100%, 100% 100%, 100% 50%, 100% 50%, 50% 100%)" })
                $("#role_img_box2").css({ clipPath: "polygon(100% 0, 100% 50%, 50% 100%, 0 100%, 0 0)" })
            }, 300)
            setTimeout(() => {
                $("#role_img_box").css({ clipPath: "polygon(100% 100%, 100% 100%, 100% 100%, 100% 100%, 100% 100%)" })
                $("#role_img_box2").css({ clipPath: "polygon(100% 0, 100% 100%, 100% 100%, 0 100%, 0 0)" })
            }, 450)
            setTimeout(() => {
                setLolPosition2(role);
            }, 600)
            setTimeout(() => {
                $("#role_img_box").css({ transition: "clip-path 0s", clipPath: "polygon(100% 0, 100% 100%, 100% 100%, 0 100%, 0 0)" })
                $("#role_img_box2").css({ transition: "clip-path 0s", clipPath: "polygon(100% 100%, 100% 100%, 100% 100%, 100% 100%, 100% 100%)" })
            }, 750)
        }
        $("#role_cp_div").stop().animate({ top: `${topLeft}%`, left: `${topLeft}%` }, 900)
    };

    const handelOnRole = (image1, index) => {
        // Check if the element is not the clicked element
        if (!$(".role_box img").eq(index).hasClass("clickedElement")) {
            $(".role_box img").eq(index).attr("src", image1).stop().animate({ width: "34px" }, 100);
            $(".role_box h2").eq(index).css({ marginTop: "37px", color: "#000" });
            $(".role_box p").eq(index).css({ color: "#000" });
        }
    };

    const handelOutRole = (image2, index) => {
        // Check if the element is not the clicked element
        if (!$(".role_box img").eq(index).hasClass("clickedElement")) {
            $(".role_box img").eq(index).attr("src", image2).stop().animate({ width: "30px" }, 500);
            $(".role_box h2").eq(index).css({ marginTop: "30px", color: "#bac2cc" });
            $(".role_box p").eq(index).css({ color: "#bac2cc" });
        }
    };


    return (
        <div className='section1' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/section3Bg.png)`, zIndex: "0" }}>
            <p className='title' style={{ left: "-70px", top: "15%" }}>-&nbsp;챔피언&nbsp;-</p>
            <div className='section1_top center'>
                <p>공식 소셜 채널 살펴보기</p>
                <a href='https://www.facebook.com/LeagueofLegendsKor/' className='mr-40'><FontAwesomeIcon icon={faFacebookF} /></a>
                <a href='https://www.instagram.com/leagueoflegendskorea/'><FontAwesomeIcon icon={faInstagram} /></a>
            </div>
            <div>
                <p className='animate__animated animate__fadeInDown' style={{ animationDelay: '0.4s', "fontFamily": 'GmarketSansMedium', fontSize: "25px", margin: "0" }}>챔피언을</p>
                <h2 className='animate__animated animate__fadeInDown' style={{ animationDelay: '0.4s', "fontFamily": 'GmarketSansMedium', fontSize: "64px", fontWeight: "bold" }}>선택하세요</h2>
                <p className='animate__animated animate__fadeIn' style={{ animationDelay: '0.8s', "fontFamily": 'GmarketSansMedium', fontSize: "15px" }}>적진으로 돌격하거나 팀원을 보조하는 등, 소환사의 협곡에는 다양한 역할군이 있습니다.</p>
            </div>
            <div className='play_box_div center animate__animated animate__fadeIn' style={{ animationDelay: '0.8s' }}>
                <a className='play_box_long' style={{ marginRight: "20px", backgroundColor: "#cfa85b" }} href=''>더 많은 챔피언 알아보기</a>
                <a className='play_box_long' href=''>지금 플레이하기</a>
            </div>


            <img className='role_bg_img' src={`${process.env.PUBLIC_URL}/${lolPosition}3.png`}></img>

            {/* 뒤에 있는 이미지 */}
            <div id='role_img_box2' className='role_img_box' style={{ clipPath: "polygon(0 0, 0 0, 0 0, 0 0, 0 0)", zIndex: "-5" }}>
                <img id='role_cp1' src={`${process.env.PUBLIC_URL}/${lolPosition}.png`} style={{ width: "650px" }}></img>
            </div>
            {/* 없어지는 이미지 */}
            <div id='role_img_box' className='role_img_box' style={{ clipPath: "polygon(0 100%, 100% 100%, 100% 0, 0 0, 0 0)", zIndex: "-4" }}>
                <div className='white_box center'>
                    <div id='role_cp_div'></div>
                </div>
                <img id='role_cp2' src={`${process.env.PUBLIC_URL}/${lolPosition2}.png`} style={{ width: "650px" }}></img>
            </div>

            <div className='circle_box'>
                <img className='cpCircle' src={`${process.env.PUBLIC_URL}/circle10.png`}></img>
                <p className='cp_name'>아칼리</p>
                <p className='cp_txt'>섬기는이 없는 암살자</p>
            </div>

            <div style={{ position: "relative" }}>
                <div className='role_boxs center'>
                    {lp.map(([title, role], index) => {
                        const image1 = `${process.env.PUBLIC_URL}/${role}1.png`;
                        const image2 = `${process.env.PUBLIC_URL}/${role}2.png`;
                        return (
                            <div className='role_box' style={{ width: "100px" }}
                                key={index} onClick={() => { handelClickRole(role, image1, image2, index) }}
                                onMouseOver={() => { handelOnRole(image1, index) }}
                                onMouseOut={() => { handelOutRole(image2, index) }}>
                                <img src={image2} alt={title} style={{ width: "30px" }} />
                                <h2>{title}</h2>
                                <p id='pc'><FontAwesomeIcon icon={faCircle} /></p>
                            </div>
                        )
                    })}
                    <div id='pc'>
                        <img className='role_circle' src={`${process.env.PUBLIC_URL}/circle4.png`}></img>
                        <img className='role_circle2' src={`${process.env.PUBLIC_URL}/circle3.png`}></img>
                        <div className='role_bar'></div>
                    </div>
                </div>
                <div className='role_bar_top'></div>
                <div className='role_bar_bottom'></div>
                <video height="290px" controls={false} muted autoPlay loop>
                    <source src={vdURL[0]} type="video/mp4" />
                </video>
            </div>
            <Section2></Section2>
        </div>
    )
}

export default Section1